// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-quotation-page {
  min-height: 100vh;
  padding: var(--space-8) max(var(--space-4), calc((100vw - 1280px) / 2)) var(--space-12);
  background: var(--bg-primary, #f4f7f7);
  color: var(--text-primary, #142624);
  font: var(--font-weight-regular) var(--font-size-body-sm) / var(--line-height-body-sm) var(--font-family-primary);
  box-sizing: border-box;
}
.customer-quotation-page *,
.customer-quotation-page *::before,
.customer-quotation-page *::after {
  box-sizing: border-box;
}
.customer-quotation-loading-bar {
  position: fixed;
  inset: 0 0 auto;
  z-index: 1;
  height: 3px;
  overflow: hidden;
  pointer-events: none;
  background: var(--border-subtle);
}
.customer-quotation-loading-bar::after {
  content: "";
  display: block;
  width: 30%;
  height: 100%;
  background: var(--interactive-default);
  animation: customer-quotation-loading 1400ms ease-in-out infinite;
}
@keyframes customer-quotation-loading {
  from { transform: translateX(-100%); }
  to { transform: translateX(350%); }
}
@media (prefers-reduced-motion: reduce) {
  .customer-quotation-loading-bar::after {
    width: 100%;
    animation: none;
    transform: none;
  }
}
.customer-quotation-brand {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  margin-bottom: var(--space-8);
  padding-bottom: var(--space-6);
  border-bottom: 1px solid var(--border-subtle);
  font-size: var(--font-size-label-md);
}
.customer-quotation-brand-mark {
  display: grid;
  place-items: center;
  flex: 0 0 var(--control-md);
  width: var(--control-md);
  height: var(--control-md);
  border-radius: var(--radius-full);
  background: var(--interactive-default, #0f766e);
  color: var(--on-interactive-primary);
}
.customer-quotation-brand strong {
  font-weight: 500;
}
.customer-quotation-brand-caption {
  margin-left: auto;
  color: var(--text-secondary);
  font-size: var(--font-size-caption-md);
}
.customer-quotation-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-5);
  margin-bottom: var(--space-8);
}
.customer-quotation-heading > div {
  min-width: 0;
  overflow-wrap: anywhere;
}
.customer-quotation-heading p {
  margin: 0 0 var(--space-2);
  font-size: var(--font-size-caption-md);
  color: var(--text-secondary, #506360);
}
.customer-quotation-heading h1 {
  margin: 0 0 var(--space-2);
  font-size: var(--font-size-h1);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-h1);
  letter-spacing: var(--letter-spacing-h1);
}
.customer-quotation-heading span {
  color: var(--text-secondary, #506360);
}
.customer-quotation-heading .customer-quotation-status {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--warning-border);
  border-radius: var(--radius-pill);
  background: var(--warning-soft, #fef8ec);
  color: var(--warning-text, #7d4412);
  white-space: nowrap;
  font-size: var(--font-size-label-sm);
  font-weight: var(--font-weight-medium);
}
.customer-quotation-status::before {
  content: "";
  width: 6px;
  height: 6px;
  flex-shrink: 0;
  border-radius: var(--radius-full);
  background: currentColor;
}
.customer-quotation-heading .is-approved {
  background: var(--success-soft, #edf9f1);
  color: var(--success-text, #105b32);
  border-color: var(--success-border);
}
.customer-quotation-document {
  overflow: hidden;
  border: 1px solid var(--border-subtle, #dce3e2);
  min-width: 0;
  border-radius: var(--radius-lg);
  background: var(--surface-primary);
  box-shadow: var(--elevation-small);
}
.customer-quotation-document .quotation-preview-document {
  margin: 0;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  gap: var(--space-6);
  padding: var(--space-8);
}
.customer-quotation-document .quotation-preview-document-header {
  gap: var(--space-6);
  align-items: flex-start;
}
.customer-quotation-document .quotation-preview-document-header h2 {
  min-width: 0;
  max-width: 60%;
  overflow-wrap: anywhere;
  font-size: var(--font-size-h4);
}
.customer-quotation-document .quotation-preview-document-header h3 {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
  letter-spacing: var(--letter-spacing-h2);
}
.customer-quotation-document .quotation-preview-details {
  gap: var(--space-4);
  padding: var(--space-4);
  border-radius: var(--radius-md);
  background: var(--surface-secondary);
}
.customer-quotation-document .quotation-preview-details > div {
  min-width: 0;
  gap: var(--space-2);
  overflow-wrap: anywhere;
}
.customer-quotation-document .quotation-preview-table-wrap {
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  scrollbar-width: thin;
}
.customer-quotation-document .quotation-preview-table {
  min-width: 640px;
  table-layout: auto;
}
.customer-quotation-document .quotation-preview-table th:first-child {
  width: 38%;
}
.customer-quotation-document .quotation-preview-table td {
  padding: var(--space-3);
  line-height: var(--line-height-body-sm);
  border-top: 1px solid var(--border-subtle);
}
.customer-quotation-document .quotation-preview-table :is(th, td):not(:first-child) {
  white-space: nowrap;
}
.customer-quotation-document .quotation-preview-table td:first-child {
  min-width: 180px;
  overflow-wrap: anywhere;
}
.customer-quotation-document .quotation-preview-bottom-grid {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);
  gap: var(--space-8);
  align-items: start;
}
.customer-quotation-document .quotation-preview-copy {
  min-width: 0;
  overflow-wrap: anywhere;
}
.customer-quotation-document .quotation-preview-copy p {
  white-space: pre-line;
  line-height: var(--line-height-body-md);
}
.customer-quotation-document .quotation-preview-totals {
  min-width: 0;
  padding: var(--space-5);
  border-radius: var(--radius-md);
  background: var(--surface-secondary);
}
.customer-quotation-document .quotation-preview-totals > div {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  align-items: start;
  gap: var(--space-3);
}
.customer-quotation-document .quotation-preview-totals strong {
  min-width: 0;
  max-width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  text-align: right;
}
.customer-quotation-document .quotation-preview-total strong {
  display: block;
  font-size: var(--font-size-money-lg);
}
.customer-quotation-document .quotation-preview-total small {
  display: block;
}
.customer-quotation-review-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  align-items: start;
  gap: var(--space-6);
}
.customer-quotation-actions {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  position: sticky;
  top: var(--space-6);
  min-width: 0;
  padding: var(--space-6);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-lg);
  background: var(--surface-primary, #fff);
  box-shadow: var(--elevation-small);
}
.customer-quotation-actions h2 {
  margin: 0;
  font-size: var(--font-size-h4);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-h4);
}
.customer-quotation-review-layout:not(.is-complete) .customer-quotation-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.customer-quotation-review-layout:not(.is-complete) .customer-quotation-actions-intro,
.customer-quotation-actions > .is-primary,
.customer-quotation-actions > .customer-quotation-approval-note {
  grid-column: 1 / -1;
}
.customer-quotation-action-icon {
  display: grid;
  place-items: center;
  width: var(--control-md);
  height: var(--control-md);
  margin-bottom: var(--space-4);
  border-radius: var(--radius-md);
  background: var(--interactive-soft);
  color: var(--interactive-default);
}
.customer-quotation-action-icon svg {
  width: var(--icon-md);
  height: var(--icon-md);
}
.customer-quotation-review-layout.is-complete {
  grid-template-columns: minmax(0, 1fr);
}
.customer-quotation-review-layout.is-complete .customer-quotation-actions {
  position: static;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: var(--space-4);
  padding: var(--space-6);
  border-color: var(--border-default);
  border-radius: var(--radius-lg);
  box-shadow: var(--elevation-small);
}
.customer-quotation-review-layout.is-complete .customer-quotation-actions > div {
  min-width: 0;
}
.customer-quotation-review-layout.is-complete .customer-quotation-actions h2 {
  font-size: var(--font-size-h4);
  line-height: 1.4;
  font-weight: 500;
}
.customer-quotation-review-layout.is-complete .customer-quotation-actions p {
  margin: var(--space-1) 0 0;
  font-size: var(--font-size-body-sm);
  overflow-wrap: anywhere;
}
.customer-quotation-review-layout.is-complete .customer-quotation-actions > :is(button, a) {
  width: auto;
  min-width: var(--space-24);
  min-height: var(--control-lg);
  padding-inline: var(--space-5);
  border-radius: var(--radius-md);
  transition: background-color var(--duration-normal), border-color var(--duration-normal);
}
.customer-quotation-review-layout.is-complete .customer-quotation-actions > button:hover {
  background: var(--surface-secondary);
  border-color: var(--border-strong);
}
.customer-quotation-review-layout.is-complete .customer-quotation-pdf-button {
  background: var(--interactive-default);
  border-color: var(--interactive-default);
  color: var(--text-inverse);
}
.customer-quotation-review-layout.is-complete .customer-quotation-pdf-button:hover {
  background: var(--interactive-hover);
  border-color: var(--interactive-hover);
}
.customer-quotation-review-layout.is-complete .customer-quotation-pdf-button:active {
  background: var(--interactive-pressed);
  border-color: var(--interactive-pressed);
}
.customer-quotation-actions p {
  margin: var(--space-2) 0 0;
  color: var(--text-secondary, #506360);
  overflow-wrap: anywhere;
}
.customer-quotation-actions > p.customer-quotation-approval-note {
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);
  margin: 0;
  padding-top: var(--space-4);
  border-top: 1px solid var(--border-subtle);
  font-size: var(--font-size-body-xs);
  line-height: var(--line-height-body-xs);
}
.customer-quotation-approval-note svg {
  flex: 0 0 var(--icon-sm);
  width: var(--icon-sm);
  height: var(--icon-sm);
  margin-top: 1px;
  color: var(--interactive-default);
}
.customer-quotation-page button,
.customer-quotation-pdf-button,
.customer-quotation-signature-dialog button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: var(--control-lg);
  padding: var(--space-2) var(--space-4);
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md);
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: var(--font-weight-medium) var(--font-size-label-md) / var(--line-height-label-md) var(--font-family-primary);
  cursor: pointer;
  transition: background-color var(--duration-fast), border-color var(--duration-fast);
}
.customer-quotation-actions > button,
.customer-quotation-pdf-button {
  width: 100%;
  box-sizing: border-box;
  text-decoration: none;
}
.customer-quotation-page button.is-primary,
.customer-quotation-signature-dialog button.is-primary {
  border-color: var(--interactive-default, #0f766e);
  background: var(--interactive-default, #0f766e);
  color: var(--on-interactive-primary);
}
.customer-quotation-page button:not(:disabled):hover,
.customer-quotation-pdf-button:hover,
.customer-quotation-signature-dialog button:not(:disabled):hover {
  background: var(--surface-secondary);
  border-color: var(--border-strong);
}
.customer-quotation-page button.is-primary:not(:disabled):hover,
.customer-quotation-signature-dialog button.is-primary:not(:disabled):hover {
  background: var(--interactive-hover);
  border-color: var(--interactive-hover);
}
.customer-quotation-page button.is-primary:not(:disabled):active,
.customer-quotation-signature-dialog button.is-primary:not(:disabled):active {
  background: var(--interactive-pressed);
  border-color: var(--interactive-pressed);
}
.customer-quotation-page button:disabled,
.customer-quotation-signature-dialog button:disabled {
  opacity: 0.55;
  cursor: default;
}
.customer-quotation-page button:focus-visible,
.customer-quotation-pdf-button:focus-visible,
.customer-quotation-signature-dialog button:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 3px;
}
@media (max-width: 980px) {
  .customer-quotation-review-layout {
    grid-template-columns: 1fr;
  }
  .customer-quotation-actions {
    position: static;
  }
  .customer-quotation-document .quotation-preview-bottom-grid {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
}
.customer-quotation-message {
  padding: 48px 24px;
  text-align: center;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 14px;
  background: var(--surface-primary, #fff);
}
.customer-quotation-message h1 {
  margin: 0 0 12px;
  font-size: 24px;
}
.customer-quotation-message p {
  margin: 0 0 20px;
  color: var(--text-secondary, #506360);
}
.customer-quotation-closed {
  box-sizing: border-box;
  width: 100%;
  max-width: 40rem;
  margin: clamp(var(--space-8), 8vh, var(--space-20)) auto 0;
  padding: var(--space-10) var(--space-6);
  border-color: var(--border-default);
  border-radius: var(--radius-lg);
  box-shadow: var(--elevation-small);
}
.customer-quotation-closed:focus {
  outline: none;
}
.customer-quotation-closed > .success-checkmark {
  display: block;
  margin: 0 auto var(--space-5);
}
.customer-quotation-closed-icon {
  display: grid;
  place-items: center;
  width: var(--space-16);
  height: var(--space-16);
  margin: 0 auto var(--space-5);
  border-radius: var(--radius-full);
  background: var(--interactive-soft);
  color: var(--interactive-default);
}
.customer-quotation-closed-icon svg {
  width: var(--icon-lg);
  height: var(--icon-lg);
}
.customer-quotation-closed-number {
  display: block;
  margin-bottom: var(--space-2);
  font-size: var(--font-size-body-xs);
  color: var(--text-secondary);
  overflow-wrap: anywhere;
}
.customer-quotation-closed h1 {
  font-size: var(--font-size-h3);
  font-weight: 500;
  line-height: 1.35;
}
.customer-quotation-closed p {
  margin: var(--space-2) 0 0;
}
.customer-quotation-success {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 20px;
  padding: 24px;
  border: 1px solid var(--success-text, #105b32);
  border-radius: 10px;
  background: var(--success-soft, #edf9f1);
  color: var(--success-text, #105b32);
}
.customer-quotation-success p {
  margin: 2px 0 0;
}
.customer-quotation-success-copy {
  min-width: 0;
  overflow-wrap: anywhere;
}
.customer-quotation-success h2 {
  margin: 0 0 8px;
  font-size: var(--font-size-h3, 22px);
  font-weight: 600;
  line-height: 1.35;
}
.customer-quotation-success dl {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 28px;
  margin: 16px 0 0;
  font-size: var(--font-size-body-xs, 12px);
}
.customer-quotation-success dt {
  color: var(--text-secondary);
}
.customer-quotation-success dd {
  margin: 2px 0 0;
  font-weight: 500;
}
.customer-quotation-success.is-animated .customer-quotation-success-copy {
  animation: quotation-success-reveal 400ms ease-out 650ms both;
}
@keyframes quotation-success-reveal {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}
@media (prefers-reduced-motion: reduce) {
  .customer-quotation-success.is-animated .customer-quotation-success-copy {
    animation: none;
  }
}
.customer-quotation-error {
  color: var(--danger-text, #a3301f);
  font-size: 13px;
}
.customer-quotation-signature-dialog.MuiPaper-root {
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 14px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 400 14px/1.55 var(--font-family-primary, "Lexend", sans-serif);
}
.customer-quotation-signature-dialog > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}
.customer-quotation-signature-dialog h2 {
  margin: 0;
  font-size: 19px;
  font-weight: 600;
}
.customer-quotation-signature-dialog > header button {
  width: 32px;
  min-height: 32px;
  padding: 0;
  border: 0;
}
.customer-quotation-signature-body {
  padding: 24px;
}
.customer-quotation-signature-body p {
  margin: 0 0 16px;
  color: var(--text-secondary, #506360);
}
.customer-quotation-signature-pad {
  overflow: hidden;
  border: 1px dashed var(--border-strong, #aebab8);
  border-radius: 10px;
  background: #fff;
}
.customer-quotation-signature-canvas {
  display: block;
  width: 100%;
  height: 220px;
  touch-action: none;
}
.customer-quotation-signature-dialog button.customer-quotation-clear-signature {
  min-height: 32px;
  margin: 8px 0 16px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--interactive-default, #0f766e);
}
.customer-quotation-signature-body p.customer-quotation-error {
  margin: 12px 0 0;
  color: var(--danger-text, #a3301f);
}
.customer-quotation-signature-dialog > footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid var(--border-subtle, #dce3e2);
}
@media (max-width: 600px) {
  .customer-quotation-brand {
    margin-bottom: var(--space-6);
    padding-bottom: var(--space-5);
  }
  .customer-quotation-brand-caption {
    display: none;
  }
  .customer-quotation-document .quotation-preview-document {
    padding: var(--space-5) var(--space-4);
    gap: var(--space-5);
  }
  .customer-quotation-document .quotation-preview-document-header {
    flex-direction: row;
    flex-wrap: wrap;
    gap: var(--space-4);
  }
  .customer-quotation-document .quotation-preview-document-header h3 {
    font-size: var(--font-size-h3);
  }
  .customer-quotation-document .quotation-preview-details {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .customer-quotation-document .quotation-preview-bottom-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: var(--space-5);
  }
  .customer-quotation-actions {
    padding: var(--space-5);
  }
  .customer-quotation-review-layout.is-complete .customer-quotation-actions {
    grid-template-columns: minmax(0, 1fr);
    padding: var(--space-5);
  }
  .customer-quotation-success {
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 24px 16px;
    text-align: center;
  }
  .customer-quotation-success dl {
    justify-content: center;
  }
  .customer-quotation-page {
    padding-top: 20px;
  }
  .customer-quotation-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }
  .customer-quotation-heading h1 {
    font-size: 24px;
  }
  .customer-quotation-actions {
    gap: 16px;
  }
  .customer-quotation-signature-body {
    padding: 20px 16px;
  }
  .customer-quotation-signature-dialog > header,
  .customer-quotation-signature-dialog > footer {
    padding: 16px;
  }
  .customer-quotation-signature-dialog h2 {
    font-size: 17px;
  }
  .customer-quotation-signature-dialog > footer button {
    flex: 1 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/Quotation/customerQuotation.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,uFAAuF;EACvF,sCAAsC;EACtC,mCAAmC;EACnC,iHAAiH;EACjH,sBAAsB;AACxB;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,eAAe;EACf,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,YAAY;EACZ,sCAAsC;EACtC,iEAAiE;AACnE;AACA;EACE,OAAO,4BAA4B,EAAE;EACrC,KAAK,2BAA2B,EAAE;AACpC;AACA;EACE;IACE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,8BAA8B;EAC9B,6CAA6C;EAC7C,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;EACzB,iCAAiC;EACjC,+CAA+C;EAC/C,oCAAoC;AACtC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,qCAAqC;AACvC;AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,wCAAwC;EACxC,kCAAkC;EAClC,wCAAwC;AAC1C;AACA;EACE,qCAAqC;AACvC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,uCAAuC;EACvC,iCAAiC;EACjC,wCAAwC;EACxC,mCAAmC;EACnC,mBAAmB;EACnB,oCAAoC;EACpC,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,cAAc;EACd,iCAAiC;EACjC,wBAAwB;AAC1B;AACA;EACE,wCAAwC;EACxC,mCAAmC;EACnC,mCAAmC;AACrC;AACA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,YAAY;EACZ,+BAA+B;EAC/B,kCAAkC;EAClC,kCAAkC;AACpC;AACA;EACE,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,wCAAwC;AAC1C;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,oCAAoC;AACtC;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,uCAAuC;EACvC,0CAA0C;AAC5C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,uDAAuD;EACvD,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,uCAAuC;AACzC;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,oDAAoD;EACpD,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,+CAA+C;EAC/C,+BAA+B;EAC/B,wCAAwC;EACxC,kCAAkC;AACpC;AACA;EACE,SAAS;EACT,8BAA8B;EAC9B,sCAAsC;EACtC,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,gDAAgD;AAClD;AACA;;;EAGE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;EACzB,6BAA6B;EAC7B,+BAA+B;EAC/B,mCAAmC;EACnC,iCAAiC;AACnC;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,0BAA0B;EAC1B,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,wFAAwF;AAC1F;AACA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;AACA;EACE,sCAAsC;EACtC,wCAAwC;EACxC,0BAA0B;AAC5B;AACA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;AACA;EACE,sCAAsC;EACtC,wCAAwC;AAC1C;AACA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,0CAA0C;EAC1C,mCAAmC;EACnC,uCAAuC;AACzC;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,iCAAiC;AACnC;AACA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,6BAA6B;EAC7B,sCAAsC;EACtC,gDAAgD;EAChD,+BAA+B;EAC/B,wCAAwC;EACxC,mCAAmC;EACnC,kHAAkH;EAClH,eAAe;EACf,oFAAoF;AACtF;AACA;;EAEE,WAAW;EACX,sBAAsB;EACtB,qBAAqB;AACvB;AACA;;EAEE,iDAAiD;EACjD,+CAA+C;EAC/C,oCAAoC;AACtC;AACA;;;EAGE,oCAAoC;EACpC,kCAAkC;AACpC;AACA;;EAEE,oCAAoC;EACpC,sCAAsC;AACxC;AACA;;EAEE,sCAAsC;EACtC,wCAAwC;AAC1C;AACA;;EAEE,aAAa;EACb,eAAe;AACjB;AACA;;;EAGE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oDAAoD;EACtD;AACF;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,qCAAqC;AACvC;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,0DAA0D;EAC1D,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,iCAAiC;EACjC,mCAAmC;EACnC,iCAAiC;AACnC;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,mCAAmC;EACnC,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,8CAA8C;EAC9C,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;AACrC;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yCAAyC;AAC3C;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,oEAAoE;AACtE;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,sDAAsD;AACxD;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,qCAAqC;AACvC;AACA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,0CAA0C;AAC5C;AACA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,mDAAmD;AACrD;AACA;EACE;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;EACA;IACE,aAAa;EACf;EACA;IACE,sCAAsC;IACtC,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,gDAAgD;EAClD;EACA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qCAAqC;IACrC,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,SAAO;EACT;AACF","sourcesContent":[".customer-quotation-page {\n  min-height: 100vh;\n  padding: var(--space-8) max(var(--space-4), calc((100vw - 1280px) / 2)) var(--space-12);\n  background: var(--bg-primary, #f4f7f7);\n  color: var(--text-primary, #142624);\n  font: var(--font-weight-regular) var(--font-size-body-sm) / var(--line-height-body-sm) var(--font-family-primary);\n  box-sizing: border-box;\n}\n.customer-quotation-page *,\n.customer-quotation-page *::before,\n.customer-quotation-page *::after {\n  box-sizing: border-box;\n}\n.customer-quotation-loading-bar {\n  position: fixed;\n  inset: 0 0 auto;\n  z-index: 1;\n  height: 3px;\n  overflow: hidden;\n  pointer-events: none;\n  background: var(--border-subtle);\n}\n.customer-quotation-loading-bar::after {\n  content: \"\";\n  display: block;\n  width: 30%;\n  height: 100%;\n  background: var(--interactive-default);\n  animation: customer-quotation-loading 1400ms ease-in-out infinite;\n}\n@keyframes customer-quotation-loading {\n  from { transform: translateX(-100%); }\n  to { transform: translateX(350%); }\n}\n@media (prefers-reduced-motion: reduce) {\n  .customer-quotation-loading-bar::after {\n    width: 100%;\n    animation: none;\n    transform: none;\n  }\n}\n.customer-quotation-brand {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  margin-bottom: var(--space-8);\n  padding-bottom: var(--space-6);\n  border-bottom: 1px solid var(--border-subtle);\n  font-size: var(--font-size-label-md);\n}\n.customer-quotation-brand-mark {\n  display: grid;\n  place-items: center;\n  flex: 0 0 var(--control-md);\n  width: var(--control-md);\n  height: var(--control-md);\n  border-radius: var(--radius-full);\n  background: var(--interactive-default, #0f766e);\n  color: var(--on-interactive-primary);\n}\n.customer-quotation-brand strong {\n  font-weight: 500;\n}\n.customer-quotation-brand-caption {\n  margin-left: auto;\n  color: var(--text-secondary);\n  font-size: var(--font-size-caption-md);\n}\n.customer-quotation-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-5);\n  margin-bottom: var(--space-8);\n}\n.customer-quotation-heading > div {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n.customer-quotation-heading p {\n  margin: 0 0 var(--space-2);\n  font-size: var(--font-size-caption-md);\n  color: var(--text-secondary, #506360);\n}\n.customer-quotation-heading h1 {\n  margin: 0 0 var(--space-2);\n  font-size: var(--font-size-h1);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-h1);\n  letter-spacing: var(--letter-spacing-h1);\n}\n.customer-quotation-heading span {\n  color: var(--text-secondary, #506360);\n}\n.customer-quotation-heading .customer-quotation-status {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding: var(--space-2) var(--space-3);\n  border: 1px solid var(--warning-border);\n  border-radius: var(--radius-pill);\n  background: var(--warning-soft, #fef8ec);\n  color: var(--warning-text, #7d4412);\n  white-space: nowrap;\n  font-size: var(--font-size-label-sm);\n  font-weight: var(--font-weight-medium);\n}\n.customer-quotation-status::before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  flex-shrink: 0;\n  border-radius: var(--radius-full);\n  background: currentColor;\n}\n.customer-quotation-heading .is-approved {\n  background: var(--success-soft, #edf9f1);\n  color: var(--success-text, #105b32);\n  border-color: var(--success-border);\n}\n.customer-quotation-document {\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  min-width: 0;\n  border-radius: var(--radius-lg);\n  background: var(--surface-primary);\n  box-shadow: var(--elevation-small);\n}\n.customer-quotation-document .quotation-preview-document {\n  margin: 0;\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n  gap: var(--space-6);\n  padding: var(--space-8);\n}\n.customer-quotation-document .quotation-preview-document-header {\n  gap: var(--space-6);\n  align-items: flex-start;\n}\n.customer-quotation-document .quotation-preview-document-header h2 {\n  min-width: 0;\n  max-width: 60%;\n  overflow-wrap: anywhere;\n  font-size: var(--font-size-h4);\n}\n.customer-quotation-document .quotation-preview-document-header h3 {\n  font-size: var(--font-size-h2);\n  line-height: var(--line-height-h2);\n  letter-spacing: var(--letter-spacing-h2);\n}\n.customer-quotation-document .quotation-preview-details {\n  gap: var(--space-4);\n  padding: var(--space-4);\n  border-radius: var(--radius-md);\n  background: var(--surface-secondary);\n}\n.customer-quotation-document .quotation-preview-details > div {\n  min-width: 0;\n  gap: var(--space-2);\n  overflow-wrap: anywhere;\n}\n.customer-quotation-document .quotation-preview-table-wrap {\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n  scrollbar-width: thin;\n}\n.customer-quotation-document .quotation-preview-table {\n  min-width: 640px;\n  table-layout: auto;\n}\n.customer-quotation-document .quotation-preview-table th:first-child {\n  width: 38%;\n}\n.customer-quotation-document .quotation-preview-table td {\n  padding: var(--space-3);\n  line-height: var(--line-height-body-sm);\n  border-top: 1px solid var(--border-subtle);\n}\n.customer-quotation-document .quotation-preview-table :is(th, td):not(:first-child) {\n  white-space: nowrap;\n}\n.customer-quotation-document .quotation-preview-table td:first-child {\n  min-width: 180px;\n  overflow-wrap: anywhere;\n}\n.customer-quotation-document .quotation-preview-bottom-grid {\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);\n  gap: var(--space-8);\n  align-items: start;\n}\n.customer-quotation-document .quotation-preview-copy {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n.customer-quotation-document .quotation-preview-copy p {\n  white-space: pre-line;\n  line-height: var(--line-height-body-md);\n}\n.customer-quotation-document .quotation-preview-totals {\n  min-width: 0;\n  padding: var(--space-5);\n  border-radius: var(--radius-md);\n  background: var(--surface-secondary);\n}\n.customer-quotation-document .quotation-preview-totals > div {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  align-items: start;\n  gap: var(--space-3);\n}\n.customer-quotation-document .quotation-preview-totals strong {\n  min-width: 0;\n  max-width: 100%;\n  overflow-x: auto;\n  white-space: nowrap;\n  text-align: right;\n}\n.customer-quotation-document .quotation-preview-total strong {\n  display: block;\n  font-size: var(--font-size-money-lg);\n}\n.customer-quotation-document .quotation-preview-total small {\n  display: block;\n}\n.customer-quotation-review-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 320px;\n  align-items: start;\n  gap: var(--space-6);\n}\n.customer-quotation-actions {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-4);\n  position: sticky;\n  top: var(--space-6);\n  min-width: 0;\n  padding: var(--space-6);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-lg);\n  background: var(--surface-primary, #fff);\n  box-shadow: var(--elevation-small);\n}\n.customer-quotation-actions h2 {\n  margin: 0;\n  font-size: var(--font-size-h4);\n  font-weight: var(--font-weight-medium);\n  line-height: var(--line-height-h4);\n}\n.customer-quotation-review-layout:not(.is-complete) .customer-quotation-actions {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n.customer-quotation-review-layout:not(.is-complete) .customer-quotation-actions-intro,\n.customer-quotation-actions > .is-primary,\n.customer-quotation-actions > .customer-quotation-approval-note {\n  grid-column: 1 / -1;\n}\n.customer-quotation-action-icon {\n  display: grid;\n  place-items: center;\n  width: var(--control-md);\n  height: var(--control-md);\n  margin-bottom: var(--space-4);\n  border-radius: var(--radius-md);\n  background: var(--interactive-soft);\n  color: var(--interactive-default);\n}\n.customer-quotation-action-icon svg {\n  width: var(--icon-md);\n  height: var(--icon-md);\n}\n.customer-quotation-review-layout.is-complete {\n  grid-template-columns: minmax(0, 1fr);\n}\n.customer-quotation-review-layout.is-complete .customer-quotation-actions {\n  position: static;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto auto;\n  align-items: center;\n  gap: var(--space-4);\n  padding: var(--space-6);\n  border-color: var(--border-default);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--elevation-small);\n}\n.customer-quotation-review-layout.is-complete .customer-quotation-actions > div {\n  min-width: 0;\n}\n.customer-quotation-review-layout.is-complete .customer-quotation-actions h2 {\n  font-size: var(--font-size-h4);\n  line-height: 1.4;\n  font-weight: 500;\n}\n.customer-quotation-review-layout.is-complete .customer-quotation-actions p {\n  margin: var(--space-1) 0 0;\n  font-size: var(--font-size-body-sm);\n  overflow-wrap: anywhere;\n}\n.customer-quotation-review-layout.is-complete .customer-quotation-actions > :is(button, a) {\n  width: auto;\n  min-width: var(--space-24);\n  min-height: var(--control-lg);\n  padding-inline: var(--space-5);\n  border-radius: var(--radius-md);\n  transition: background-color var(--duration-normal), border-color var(--duration-normal);\n}\n.customer-quotation-review-layout.is-complete .customer-quotation-actions > button:hover {\n  background: var(--surface-secondary);\n  border-color: var(--border-strong);\n}\n.customer-quotation-review-layout.is-complete .customer-quotation-pdf-button {\n  background: var(--interactive-default);\n  border-color: var(--interactive-default);\n  color: var(--text-inverse);\n}\n.customer-quotation-review-layout.is-complete .customer-quotation-pdf-button:hover {\n  background: var(--interactive-hover);\n  border-color: var(--interactive-hover);\n}\n.customer-quotation-review-layout.is-complete .customer-quotation-pdf-button:active {\n  background: var(--interactive-pressed);\n  border-color: var(--interactive-pressed);\n}\n.customer-quotation-actions p {\n  margin: var(--space-2) 0 0;\n  color: var(--text-secondary, #506360);\n  overflow-wrap: anywhere;\n}\n.customer-quotation-actions > p.customer-quotation-approval-note {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-2);\n  margin: 0;\n  padding-top: var(--space-4);\n  border-top: 1px solid var(--border-subtle);\n  font-size: var(--font-size-body-xs);\n  line-height: var(--line-height-body-xs);\n}\n.customer-quotation-approval-note svg {\n  flex: 0 0 var(--icon-sm);\n  width: var(--icon-sm);\n  height: var(--icon-sm);\n  margin-top: 1px;\n  color: var(--interactive-default);\n}\n.customer-quotation-page button,\n.customer-quotation-pdf-button,\n.customer-quotation-signature-dialog button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: var(--control-lg);\n  padding: var(--space-2) var(--space-4);\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md);\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: var(--font-weight-medium) var(--font-size-label-md) / var(--line-height-label-md) var(--font-family-primary);\n  cursor: pointer;\n  transition: background-color var(--duration-fast), border-color var(--duration-fast);\n}\n.customer-quotation-actions > button,\n.customer-quotation-pdf-button {\n  width: 100%;\n  box-sizing: border-box;\n  text-decoration: none;\n}\n.customer-quotation-page button.is-primary,\n.customer-quotation-signature-dialog button.is-primary {\n  border-color: var(--interactive-default, #0f766e);\n  background: var(--interactive-default, #0f766e);\n  color: var(--on-interactive-primary);\n}\n.customer-quotation-page button:not(:disabled):hover,\n.customer-quotation-pdf-button:hover,\n.customer-quotation-signature-dialog button:not(:disabled):hover {\n  background: var(--surface-secondary);\n  border-color: var(--border-strong);\n}\n.customer-quotation-page button.is-primary:not(:disabled):hover,\n.customer-quotation-signature-dialog button.is-primary:not(:disabled):hover {\n  background: var(--interactive-hover);\n  border-color: var(--interactive-hover);\n}\n.customer-quotation-page button.is-primary:not(:disabled):active,\n.customer-quotation-signature-dialog button.is-primary:not(:disabled):active {\n  background: var(--interactive-pressed);\n  border-color: var(--interactive-pressed);\n}\n.customer-quotation-page button:disabled,\n.customer-quotation-signature-dialog button:disabled {\n  opacity: 0.55;\n  cursor: default;\n}\n.customer-quotation-page button:focus-visible,\n.customer-quotation-pdf-button:focus-visible,\n.customer-quotation-signature-dialog button:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 3px;\n}\n@media (max-width: 980px) {\n  .customer-quotation-review-layout {\n    grid-template-columns: 1fr;\n  }\n  .customer-quotation-actions {\n    position: static;\n  }\n  .customer-quotation-document .quotation-preview-bottom-grid {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n}\n.customer-quotation-message {\n  padding: 48px 24px;\n  text-align: center;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 14px;\n  background: var(--surface-primary, #fff);\n}\n.customer-quotation-message h1 {\n  margin: 0 0 12px;\n  font-size: 24px;\n}\n.customer-quotation-message p {\n  margin: 0 0 20px;\n  color: var(--text-secondary, #506360);\n}\n.customer-quotation-closed {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 40rem;\n  margin: clamp(var(--space-8), 8vh, var(--space-20)) auto 0;\n  padding: var(--space-10) var(--space-6);\n  border-color: var(--border-default);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--elevation-small);\n}\n.customer-quotation-closed:focus {\n  outline: none;\n}\n.customer-quotation-closed > .success-checkmark {\n  display: block;\n  margin: 0 auto var(--space-5);\n}\n.customer-quotation-closed-icon {\n  display: grid;\n  place-items: center;\n  width: var(--space-16);\n  height: var(--space-16);\n  margin: 0 auto var(--space-5);\n  border-radius: var(--radius-full);\n  background: var(--interactive-soft);\n  color: var(--interactive-default);\n}\n.customer-quotation-closed-icon svg {\n  width: var(--icon-lg);\n  height: var(--icon-lg);\n}\n.customer-quotation-closed-number {\n  display: block;\n  margin-bottom: var(--space-2);\n  font-size: var(--font-size-body-xs);\n  color: var(--text-secondary);\n  overflow-wrap: anywhere;\n}\n.customer-quotation-closed h1 {\n  font-size: var(--font-size-h3);\n  font-weight: 500;\n  line-height: 1.35;\n}\n.customer-quotation-closed p {\n  margin: var(--space-2) 0 0;\n}\n.customer-quotation-success {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  margin-bottom: 20px;\n  padding: 24px;\n  border: 1px solid var(--success-text, #105b32);\n  border-radius: 10px;\n  background: var(--success-soft, #edf9f1);\n  color: var(--success-text, #105b32);\n}\n.customer-quotation-success p {\n  margin: 2px 0 0;\n}\n.customer-quotation-success-copy {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n.customer-quotation-success h2 {\n  margin: 0 0 8px;\n  font-size: var(--font-size-h3, 22px);\n  font-weight: 600;\n  line-height: 1.35;\n}\n.customer-quotation-success dl {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px 28px;\n  margin: 16px 0 0;\n  font-size: var(--font-size-body-xs, 12px);\n}\n.customer-quotation-success dt {\n  color: var(--text-secondary);\n}\n.customer-quotation-success dd {\n  margin: 2px 0 0;\n  font-weight: 500;\n}\n.customer-quotation-success.is-animated .customer-quotation-success-copy {\n  animation: quotation-success-reveal 400ms ease-out 650ms both;\n}\n@keyframes quotation-success-reveal {\n  from { opacity: 0; transform: translateY(6px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n@media (prefers-reduced-motion: reduce) {\n  .customer-quotation-success.is-animated .customer-quotation-success-copy {\n    animation: none;\n  }\n}\n.customer-quotation-error {\n  color: var(--danger-text, #a3301f);\n  font-size: 13px;\n}\n.customer-quotation-signature-dialog.MuiPaper-root {\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 14px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 400 14px/1.55 var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.customer-quotation-signature-dialog > header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n.customer-quotation-signature-dialog h2 {\n  margin: 0;\n  font-size: 19px;\n  font-weight: 600;\n}\n.customer-quotation-signature-dialog > header button {\n  width: 32px;\n  min-height: 32px;\n  padding: 0;\n  border: 0;\n}\n.customer-quotation-signature-body {\n  padding: 24px;\n}\n.customer-quotation-signature-body p {\n  margin: 0 0 16px;\n  color: var(--text-secondary, #506360);\n}\n.customer-quotation-signature-pad {\n  overflow: hidden;\n  border: 1px dashed var(--border-strong, #aebab8);\n  border-radius: 10px;\n  background: #fff;\n}\n.customer-quotation-signature-canvas {\n  display: block;\n  width: 100%;\n  height: 220px;\n  touch-action: none;\n}\n.customer-quotation-signature-dialog button.customer-quotation-clear-signature {\n  min-height: 32px;\n  margin: 8px 0 16px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--interactive-default, #0f766e);\n}\n.customer-quotation-signature-body p.customer-quotation-error {\n  margin: 12px 0 0;\n  color: var(--danger-text, #a3301f);\n}\n.customer-quotation-signature-dialog > footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 16px 24px;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n@media (max-width: 600px) {\n  .customer-quotation-brand {\n    margin-bottom: var(--space-6);\n    padding-bottom: var(--space-5);\n  }\n  .customer-quotation-brand-caption {\n    display: none;\n  }\n  .customer-quotation-document .quotation-preview-document {\n    padding: var(--space-5) var(--space-4);\n    gap: var(--space-5);\n  }\n  .customer-quotation-document .quotation-preview-document-header {\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: var(--space-4);\n  }\n  .customer-quotation-document .quotation-preview-document-header h3 {\n    font-size: var(--font-size-h3);\n  }\n  .customer-quotation-document .quotation-preview-details {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .customer-quotation-document .quotation-preview-bottom-grid {\n    grid-template-columns: minmax(0, 1fr);\n    gap: var(--space-5);\n  }\n  .customer-quotation-actions {\n    padding: var(--space-5);\n  }\n  .customer-quotation-review-layout.is-complete .customer-quotation-actions {\n    grid-template-columns: minmax(0, 1fr);\n    padding: var(--space-5);\n  }\n  .customer-quotation-success {\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    padding: 24px 16px;\n    text-align: center;\n  }\n  .customer-quotation-success dl {\n    justify-content: center;\n  }\n  .customer-quotation-page {\n    padding-top: 20px;\n  }\n  .customer-quotation-heading {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 12px;\n  }\n  .customer-quotation-heading h1 {\n    font-size: 24px;\n  }\n  .customer-quotation-actions {\n    gap: 16px;\n  }\n  .customer-quotation-signature-body {\n    padding: 20px 16px;\n  }\n  .customer-quotation-signature-dialog > header,\n  .customer-quotation-signature-dialog > footer {\n    padding: 16px;\n  }\n  .customer-quotation-signature-dialog h2 {\n    font-size: 17px;\n  }\n  .customer-quotation-signature-dialog > footer button {\n    flex: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
